import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Close } from '@material-ui/icons'
import { CleanButton, Label } from '../default'
import { Box, Grid, IconButton, Modal, Paper, Tooltip, withStyles } from '@material-ui/core'
import { connect, useDispatch } from 'react-redux'

import { Loader, Alert, PrimaryButton } from '../../components/default'
import { FormPlanTable } from '../forms'
import { acPostCreatePlanTable } from '../../class/actions'


function CreatePlanTableModal({
  classes, open, onClose,
  cachedPlanTable,
  creatingPlanTable, createdPlanTableError
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const createPlanTable = () => {
    dispatch(acPostCreatePlanTable(cachedPlanTable)).then(onClose)
  }

  return (
    <Modal open={open} onClose={onClose} disableAutoFocus style={{ outline: 0 }}>
      <Paper
        square={true}
        className={classes.root + ' ' + classes.modalDiv}
      >
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Grid container spacing={2} className={classes.grid}>
            <Grid item xs={8}>
              <Label v='h6'>
                {t('modals.planTable.create.title')}
              </Label>
            </Grid>
            <Grid item xs={4} style={{ textAlign: 'right', padding: 0 }}>
              <Tooltip title={t('default.close')}>
                <IconButton onClick={onClose}>
                  <Close />
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid item xs={12}>
              <FormPlanTable />
            </Grid>
          </Grid>
        </Box>

        <div>
          <div style={{ marginTop: '15px' }}>
            {
              createdPlanTableError &&
              (createdPlanTableError.description ? (
                <Alert style={{ marginBottom: '15px' }} noMargin color="error" text={createdPlanTableError.description} />
              ) : createdPlanTableError.errors ? (
                <Alert style={{ marginBottom: '15px' }} noMargin color="error" text={t('modals.planTable.create.unknownError')} />
              ) : null)
            }
          </div>
          <div style={{ marginTop: '15px' }}>
            <Grid container style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <CleanButton onClick={onClose} style={{ marginRight: '15px' }}>
                {t('default.cancel')}
              </CleanButton>
              <PrimaryButton onClick={createPlanTable}>
                {
                  creatingPlanTable ? (
                    <Loader />
                  ) : (
                    <div>
                      {t('modals.planTable.create.action')}
                    </div>
                  )
                }
              </PrimaryButton>
            </Grid>
          </div>
        </div>
      </Paper>
    </Modal>
  )
}

CreatePlanTableModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  close: PropTypes.func
}

CreatePlanTableModal.defaultProps = {
  open: false,
  onClose: () => true,
  close: () => true
}

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    padding: theme.spacing(2),
    maxHeight: '90%',
    overflowY: 'scroll'
  },
  grid: {
    display: 'flex',
    flex: 1
  },
  modalDiv: {
    [theme.breakpoints.up('md')]: {
      width: '50%'
    },
    width: '100%',
    top: '10%',
    left: '50%',
    transform: 'translate(-50%, -10%)',
  }
})

const mapStateToProps = ({ ReducerPlanTable }) => ({
  cachedPlanTable: ReducerPlanTable.cachedPlanTable,
  creatingPlanTable: ReducerPlanTable.creatingPlanTable,
  createdPlanTableError: ReducerPlanTable.createdPlanTableError
})

export default connect(mapStateToProps)(withStyles(styles)(CreatePlanTableModal))